import { createClient } from "@liveblocks/client";
import { createRoomContext } from "@liveblocks/react";

const client = createClient({
  publicApiKey: "pk_live_1n0HzfVgxugz4yvwgXqQ5-Pb",
});

export const { RoomProvider, useList, useOthers, useUpdateMyPresence, LiveList } = createRoomContext(client);